import React from 'react';
import { AfterSubmitFunc, FormTemplate, TextInput } from 'ui-builder';
import { DetailsFieldsSet, Plan, usePlansService } from 'nekst-api';
import usePlansNavigator from '../../../../plans/plansNavigator';

export default function CreatePlanFromSetForm(
  props: {
    set: DetailsFieldsSet,
    afterSubmitFunc?: AfterSubmitFunc,
  }
) {
  const plansService = usePlansService();

  const plansNavigator = usePlansNavigator();

  return (
    <FormTemplate<{ name: string }, Plan>
      title="Create Workflow"
      submitFormFunc={async (data) => {
        const result = await plansService.createPlanFromSet(props.set.id, data.name);

        plansNavigator.openPlanPage(result.id);
        return result;
      }}
      initialData={{
        name: props.set.name,
      }}
      validationSchema={{
        name: {
          type: 'string',
          constraints: {
            required: true,
            minLength: 3,
            maxLength: 60,
          }
        }
      }}
      afterSubmitFunc={props.afterSubmitFunc}
    >
      <TextInput source="name" label="Workflow Name" />
    </FormTemplate>
  );
}
